var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"ma-auto",attrs:{"max-width":"500"}},[_c('v-card-title',{staticClass:"headline grey lighten-2 subtitle-1",attrs:{"primary-title":""}},[_c('span',[_vm._v(" Control ")])]),_c('v-card-text',[_c('Control')],1),_c('v-card-actions')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }